import React from "react";
import { TextField, Chip, Box, Typography } from "@mui/material";

const ChipInput = ({ label, values, onAdd, onDelete, inputRef }) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && e.target.value.trim() !== "") {
      onAdd(e.target.value.trim());
      e.target.value = "";
      e.preventDefault();
    }
  };

  const handleBlur = (e) => {
    const value = e.target.value.trim();
    if (!value) return;

    onAdd(value);
    e.target.value = "";
  };

  return (
    <div>
      <Typography variant="subtitle1">{label}</Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
        {values.map((item, index) => (
          <Chip key={index} label={item} onDelete={() => onDelete(index)} />
        ))}
      </Box>
      <TextField
        fullWidth
        margin="normal"
        placeholder={`Ajouter un(e) ${label.toLowerCase()}...`}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        inputRef={inputRef}
      />
    </div>
  );
};

export default ChipInput;
